import { create } from "zustand"
import { persist } from "zustand/middleware"
import localStorageNames from "@data/localStorageNames"

export const useMiniappConfirm = create(persist((set, get) => ({
    miniapp: false,
    miniappstorelogid: false,
    updateMiniappConfirm: (newMiniapp) => {
        set({ miniapp: newMiniapp })
    },
    updateMiniappConfirmId: (newMiniapp) => {
        set({ miniappstorelogid: newMiniapp })
    },
    getMiniappConfirm: () => {
        return get().miniapp
    },
    getMiniappConfirmId: () => {
        return get().miniappstorelogid
    }
}),
    {
        name: localStorageNames.MINIAPP_OK
    }
))